import { Label } from "@/components/ui/label";

interface QuestionOptionsPreviewProps {
  options: string[];
}

export const QuestionOptionsPreview = ({ options }: QuestionOptionsPreviewProps) => {
  return (
    <div className="space-y-2">
      <Label>Options (from question type)</Label>
      <div className="text-sm text-muted-foreground">Options are managed on the selected question type.</div>
      <div className="border rounded-md p-3">
        {Array.isArray(options) && options.length > 0 ? (
          <ul className="list-disc pl-6 space-y-1">
            {options.map((opt: string, idx: number) => (
              <li key={idx}>{opt}</li>
            ))}
          </ul>
        ) : (
          <span className="text-sm text-muted-foreground">No options for this type.</span>
        )}
      </div>
    </div>
  );
};

export default QuestionOptionsPreview;

